export default __webpack_public_path__ + "static/media/newWebsiteVideo.7515e70b.mp4";